import AxiosService from "plugins/TS-lib-utils-public/services/AxiosService"; 

class KitsService extends AxiosService {
    constructor() {
        super('management');
    }

    getKit = async (kitId, { cancelToken = null } = {}) => {
        return await this.get(
            `/kits/${kitId}`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }
  
    getKitsList = async (page, limit, search = null, { cancelToken = null } = {}) => {
        let query;
        if (search) {
            query = `/kits/list/?page=${page}&limit=${limit}&search=${search}`;
        } else {
            query = `/kits/list/?page=${page}&limit=${limit}`;
        }
        const response = await this.get(
            query,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
        return response;
    };

    createKit = async (data, { cancelToken = null } = {}) => {
        return await this.post(
            `/kits`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    editKit = async (data, { cancelToken = null } = {}) => {
        return await this.put(
            `/kits/${data.kitId}`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    deleteKit = async (kitId, { cancelToken = null } = {}) => {
        return await this.delete(
            `/kits/${kitId}`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    getTypes = async ({ cancelToken = null } = {}) => {
        return await this.get(
            `/kits/types`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    getCountByTypes = async ({ cancelToken = null } = {}) => {
        return await this.get(
            `/kits/count`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    getPatientKits = async (page, limit, search = null, { cancelToken = null } = {}) => {
        let query;
        if (search) {
            query = `/kits/patients/list/?page=${page}&limit=${limit}&search=${search}`;
        } else {
            query = `/kits/patients/list/?page=${page}&limit=${limit}`;
        }
        const response = await this.get(
            query,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
        return response;
    };

    updatePatientKistStatus = async (kitId, status, { cancelToken = null } = {}) => {
        return await this.put(
            `/kits/patients/${kitId}/status`,
            {status: status},
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

}
export default new KitsService();
